module.exports = __webpack_public_path__ + "img/tainan_aw.726c7460.png";